import React, { Suspense } from 'react';
import { lazyComponent } from '@unisporkal/react-lazy-component';
import { useTranslations } from '@unisporkal/localization';
import { useUser } from '@unisporkal/user';
import UsageRestrictionsWarning from '../../UsageRestrictionsWarning/UsageRestrictionsWarning';
import useOnLoad from '../../../../hooks/queries/useOnLoad';
import styles from './BatchDownloadForm.module.scss';

const AgreementComponent = lazyComponent((props) =>
  import(
    `../../../EasyAccessModal/EasyAccessAgreement/EzaAccount.${props.locale}`
  )
);

const Restrictions = () => {
  const t = useTranslations();
  const user = useUser();
  const AGREEMENT_LOCALES = [
    'de',
    'en-gb',
    'en-us',
    'en',
    'es',
    'fr',
    'it',
    'ja',
    'nl',
    'pt-br',
    'pt-pt',
    'sv',
    'zh-hk',
  ];
  const showAgreementComponent = AGREEMENT_LOCALES.includes(user.locale);
  const { response: { config: { batchAgreements } = {} } = {} } = useOnLoad();
  const easyAccessAgreement = batchAgreements?.some(
    (agreement) => agreement.productType === 'EasyAccess'
  );

  const showEzaRestrictions = () => {
    const hideEzaCheck = localStorage.getItem(
      'downloadPreferences.hideEzaAgreement'
    );
    return (
      easyAccessAgreement && !(hideEzaCheck === 'true' || hideEzaCheck === true)
    );
  };

  const ezaRestrictions = () => {
    if (showEzaRestrictions()) {
      return (
        <div>
          <section className={styles.ezaContent}>
            {showAgreementComponent && (
              <div data-testid="easy-access-agreement">
                <Suspense>
                  <AgreementComponent locale={user.locale} />
                </Suspense>
              </div>
            )}
          </section>
          <section className={styles.ezaInfo}>
            {t('eza_agreement_check_info')}
          </section>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <UsageRestrictionsWarning />
      {ezaRestrictions()}
    </>
  );
};

export default Restrictions;
